// routes
import { useEffect } from 'react';
import Router from './routes';
// theme
import ThemeConfig from './theme';
// hooks
import useAuth from './hooks/useAuth';
// components
import RtlLayout from './components/RtlLayout';
import ScrollToTop from './components/ScrollToTop';
import ThemePrimaryColor from './components/ThemePrimaryColor';
import NotistackProvider from './components/NotistackProvider';

import LoadingScreen from './components/LoadingScreen';
import LoadingScreenProvider from './components/LoadingScreenProvider';
// ----------------------------------------------------------------------

export default function App() {
  const { isInitialized } = useAuth();
  // const [buildDate, setBuildDate] = useState(null);
  useEffect(() => {
    fetch('/build-info.json')
      .then((response) => response.json())
      .then((data) => {
        // setBuildDate(data.buildDate);
        console.log(`App built on: ${data.buildDate}`);
      })
      .catch((error) => console.error('Error fetching build info:', error));
  }, []);

  return (
    <ThemeConfig>
      <ThemePrimaryColor>
        <RtlLayout>
          <NotistackProvider>
            <ScrollToTop />
            {isInitialized ? (
              <LoadingScreenProvider>
                <Router />
              </LoadingScreenProvider>
            ) : (
              <LoadingScreen
                style={{
                  position: 'fixed',
                  width: '100%',
                  top: 0,
                  backgroundColor: '#9f9f9f54',
                  zIndex: 99999
                }}
              />
            )}
          </NotistackProvider>
        </RtlLayout>
      </ThemePrimaryColor>
    </ThemeConfig>
  );
}
